import { handleRequestPost, handleRequestGet } from '../axios';
import { setLogin, getUserDetail } from '../../hooks/handleUserLocalStorage';
import { parseResult } from './GeneralFunc';
import { showMessageModal, logMessage } from '../../components/utils';

export const userLogin = async ({ username, password }) => {
    let url = '/sess/login';
    let result = await handleRequestPost(url, {
        username: username,
        password: password
    });

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);
       // console.log("paresedResult",paresedResult);
        if (paresedResult.status == 0) {
            let data = paresedResult.data;
            // data.username = username;
           // console.log("setLogin",data);
            await setLogin(data);
            // //console.log(result)
        } else {
           // alert(paresedResult.message);
            showMessageModal(paresedResult.message);
        }

        return paresedResult;
    } catch (error) {}

    return false;
};

export const userLoginMFA = async ({ username, password,secret_code,geolocation=null }) => {
    let url = '/sess/login';
    let payload = {
        username: username,
        password: password,
        secret_code:secret_code
    }

    if(geolocation && geolocation.latitude && geolocation.longitude){
        payload.geolocation = geolocation
    }
 
    let result = await handleRequestPost(url, payload);

  //  console.log("payload",payload)

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);
       // console.log("paresedResult",paresedResult);
        if (paresedResult.status == 0) {
            let data = paresedResult.data;
            // data.username = username;
           // console.log("setLogin",data);
            await setLogin(data);
            // //console.log(result)
        } else {
           // alert(paresedResult.message);
            showMessageModal(paresedResult.message);
        }

        return paresedResult;
    } catch (error) {}

    return false;
};

export const userLogout = async () => {
    let url = '/sess/logout';
    let result = await handleRequestPost(url, {});

   // console.log('logout', result);
    // console.log(result)

    try {
        let paresedResult = JSON.parse(result);
        if (paresedResult.status == 0) {
            return true;
        }
    } catch (error) {}

    return false;
};

export const userRegister = async ({ username, password,type,identity,email,answers,mode }:any) => {
    let url = '/sess/register';

    let param: any = {
        "username": username,
        "password": password,
        "type": type,
        "identity": identity,
        "email": email,
        "mode":mode
    };

    if (answers) {
        param.answers = answers;
    }

    logMessage({ ...param, password: '******' });

    let result = await handleRequestPost(url, param);

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);
        if (paresedResult.status == 0) {
            let data = paresedResult.data;
            // data.username = username;

            await setLogin(data);
            // //console.log(result)
        } else {
            // alert(paresedResult.message);
            showMessageModal(paresedResult.message);
        }

        return paresedResult;
    } catch (error) {}

    return false;
};

export const userActivate = async ({ token }:any) => {
    
    let url = '/sess/activate';
    let result = await handleRequestPost(url, {
        "token": token,
    }
    );

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);
        if (paresedResult.status == 0) {
            let data = paresedResult.data;
            // data.username = username;

            await setLogin(data);
            // //console.log(result)
        } else {
           // alert(paresedResult.message);
            showMessageModal(paresedResult.message);
        }

        return paresedResult;
    } catch (error) {}

    return false;
};

export const userPasswordRules = async () => {

    let url = '/sess/password/rules';
    let result = await handleRequestGet(url, {

    }
    );

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);


        return paresedResult.data;
    } catch (error) {}

    return false;
};
export const userCredentialRules = async () => {
    
    let url = '/sess/credential/rules';
    let result = await handleRequestGet(url, {
      
    }
    );

    // console.log(result);

    try {
        let paresedResult = JSON.parse(result);
 

        return paresedResult.data;
    } catch (error) {}

    return false;
};
